import { useCallback } from 'react';
import { AxiosResponse } from 'axios';

import { useBaseI18n } from './i18n-hooks';

const useGetError = () => {
	const errors = useBaseI18n(i18n => i18n.error);

	return useCallback((error: AxiosResponse) => {
		switch (error?.status) {
			case 413:
				return errors.tooHeavy;
			case 400:
				if (error?.data.message[0] === 'Please enter a phone number without any spaces or dashes') return errors.phoneWoOther;
				else return errors.invalidInfo;
			case 500:
				if (error.data?.code === "ENAMETOOLONG") return errors.fileNameTooLong;
				else return errors.generalSystem;
			case 409:
				if (error?.data.message === 'association name already exists') return errors.associationNameExists;
				return errors.phoneExists;
			default: return errors.generalSystem;
		}
	}, [errors]);
}

export default useGetError;